/* APP MENU */
export const INIT_MENU = 'INIT_MENU';
export const INIT_MENU_SUCCESS = 'INIT_MENU_SUCCESS';
export const CHANGE_ACTIVE_MENU_FROM_LOCATION = 'CHANGE_ACTIVE_MENU_FROM_LOCATION';
export const CHANGE_ACTIVE_MENU_FROM_LOCATION_SUCCESS = 'CHANGE_ACTIVE_MENU_FROM_LOCATION_SUCCESS';
export const TOGGLE_MENU_ITEM = 'TOGGLE_MENU_ITEM';
export const SET_ACTIVE_MENU_ITEM = 'SET_ACTIVE_MENU_ITEM';
export const CLEAR_MENU = 'CLEAR_MENU';
